// extracted by mini-css-extract-plugin
export var button = "PaymentForm-module__button___ntag5";
export var divider = "PaymentForm-module__divider___LRoFl";
export var error = "PaymentForm-module__error____CSSI";
export var fine = "PaymentForm-module__fine___q_mLT";
export var form = "PaymentForm-module__form___tNmdg";
export var grid = "PaymentForm-module__grid___wMSUP";